import React, { Component, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import FormTextField from '../../../components/inputs/FormTextField/FormTextField'
import Button from '../../../components/buttons/Button'
import { selectGetAccounts, selectGetBanks } from '../../../selectors/banks.selector'
import { getAccounts, getBanks } from '../../../actions/banks.actions'
import { Td, Tr } from 'react-super-responsive-table'
import { TableV2 } from '../../../components'

const BankAccountListModal = props => {
  const dispatch = useDispatch()
  const types = [
    { id: 1, label: 'Monetaria' },
    { id: 2, label: 'Ahorro' },
  ]

  const [profileState, setProfileState] = useState(props)
  const [showModal, setShowModal] = useState(false)
  const [selectedAccount, setSelectedAccount] = useState({})

  const banks = useSelector(selectGetBanks)
  const accounts = useSelector(selectGetAccounts)

  useEffect(() => {
    // dispatch(getBanks())
    // dispatch(getAccounts())
  }, [])

  useEffect(() => {
    // setProfileState(props)
    // setShowModal(props.showModal)
    // setSelectedAccount(props.selected)
  }, [props])

  const getBank = id => {
    let found = banks.find(f => f.id === id)
    return found ? found.name : ''
  }

  const getHeaders = () => {
    return [
      { label: 'Nombre', show: true, value: ['name'], type: 'text', className: 'mini' },
      {
        label: 'Banco',
        show: true,
        value: ['bankC'],
        type: 'text',
        className: 'mini',
        custom: item => (item.bankC = getBank(item.bank)),
      },
      {
        label: 'No. cuenta',
        show: true,
        value: ['accountNumber'],
        type: 'text',
        className: 'mini',
      },
      {
        label: 'Tipo',
        show: true,
        value: ['tipoCuenta'],
        type: 'text',
        className: 'mini',
        custom: item => (item.tipoCuenta = item.type == 1 ? 'Monetaria' : 'Ahorro'),
      },
      {
        label: 'A Nombre',
        show: true,
        value: ['toName'],
        type: 'text',
        className: 'mini',
      },
      { config: true, show: true, label: '', className: 'mini' },
    ]
  }
  return (
    <Modal show={showModal} size={'lg'} centered onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Cuentas Bancarias </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {}
        <TableV2
          headers={getHeaders()}
          items={accounts}
          mobileAuto
          isSelected={item => item.id === selectedAccount.id}
          onClickTr={(e, item) => setSelectedAccount(item)}
          getItems={selected => {
            if (selected !== null) selected.map(item => setSelectedAccount(item))
            else {
              setSelectedAccount({})
            }
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            console.log(selectedAccount)
            setShowModal(false)
          }}
          style={{ maxWidth: '100%' }}>
          Cerrar{' '}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default BankAccountListModal
